import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/home/home'

Vue.use(Router)

export default new Router({
 // mode:'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component:resolve=>require(['@/views/homepage'],resolve),
    },
    {
      path: '/admin/associationdetails',
      name: 'associationdetails',
      component:resolve=>require(['@/views/admin/association_details'],resolve)
    },
    {
      path: '/admin/userlogin',
      name: 'userlogin',
      component:resolve=>require(['@/views/admin/user_login'],resolve)
    },
    {
      path: '/backstage/associationintroduce',
      name: 'associationintroduce',
      component:resolve=>require(['@/views/backstage/association_introduce'],resolve)
    },
    {
      path: '/register',
      name: 'register',
      component:resolve=>require(['@/views/register'],resolve)
    },
    {
      path: '/announcement',
      name: 'announcement',
      component:resolve=>require(['@/views/announcement'],resolve)
    },
    {
      path: '/admin/newsdetail',
      name: 'newsdetail',
      component:resolve=>require(['@/views/admin/news_detail'],resolve)
    },
    {
      path: '/home',
      name: 'home',
      component:resolve=>require(['@/views/home'],resolve),
      children:[
        {
          path: '/applymember',
          name: 'ApplyMember',
          component:resolve=>require(['@/views/member/apply_member'],resolve)
        },
        {
          path: '/memberapproval',
          name: 'memberapproval',
          component:resolve=>require(['@/views/admin/membership_approval'],resolve)
        },
        {
          path: '/memberdisplay',
          name: 'memberdisplay',
          component:resolve=>require(['@/views/admin/member_display'],resolve)
        },
        {
          path: '/membersuccess',
          name: 'membersuccess',
          component:resolve=>require(['@/views/admin/member_success'],resolve)
        },
        {
          path: '/changeapproval',
          name: 'changeapproval',
          component:resolve=>require(['@/views/admin/change_approval'],resolve)
        },
        {
          path: '/memberdetails',
          name: 'memberdetails',
          component:resolve=>require(['@/views/admin/member_details'],resolve)
        },
        {
          path: '/organizationmember',
          name: 'organizationmember',
          component:resolve=>require(['@/views/admin/organization_member'],resolve)
        },
        {
          path: '/personalmember',
          name: 'personalmember',
          component:resolve=>require(['@/views/admin/personal_member'],resolve)
        },
        {
          path: '/certificateapproval',
          name: 'certificateapproval',
          component:resolve=>require(['@/views/admin/certificate_approval'],resolve)
        },
        {
          path: '/certificatehandle',
          name: 'certificatehandle',
          component:resolve=>require(['@/views/admin/certificate_handle'],resolve)
        },
        {
          path: '/certificatepost',
          name: 'certificatepost',
          component:resolve=>require(['@/views/admin/certificate_post'],resolve)
        },
        {
          path: '/certificatefinish',
          name: 'certificatefinish',
          component:resolve=>require(['@/views/admin/certificate_finish'],resolve)
        },
        {
          path: '/paymentapproval',
          name: 'paymentapproval',
          component:resolve=>require(['@/views/admin/payment_approval'],resolve)
        },
        {
          path: '/paymenttrainingapproval',
          name: 'paymenttrainingapproval',
          component:resolve=>require(['@/views/admin/payment_training_approval'],resolve)
        },
        {
          path: '/paymentstatistics',
          name: 'paymentstatistics',
          component:resolve=>require(['@/views/admin/payment_statistics'],resolve)
        },
        {
          path: '/trainingactivity',
          name: 'trainingactivity',
          component:resolve=>require(['@/views/admin/training_activity'],resolve)
        },
        {
          path: '/trainingcertificateprint',
          name: 'trainingcertificateprint',
          component:resolve=>require(['@/views/admin/training_certificate_print'],resolve)
        },
        {
          path: '/trainingcertificatepost',
          name: 'trainingcertificatepost',
          component:resolve=>require(['@/views/admin/training_certificate_post'],resolve)
        },
        {
          path: '/handlecertificate',
          name: 'handleCertificate',
          component:resolve=>require(['@/views/member/handle_certificate'],resolve)
        },
        {
          path: '/membershipdues',
          name: 'membershipDues',
          component:resolve=>require(['@/views/member/membership_dues'],resolve)
        },
        {
          path: '/trainningfee',
          name: 'trainningFee',
          component:resolve=>require(['@/views/member/trainning_fee'],resolve)
        },
        {
          path: '/trainapply',
          name: 'trainApply',
          component:resolve=>require(['@/views/member/train_apply'],resolve)
        },
        {
          path: '/trainperson',
          name: 'trainPerson',
          component:resolve=>require(['@/views/member/train_person'],resolve)
        },
        {
          path: '/branchdynamic',
          name: 'branchdynamic',
          component:resolve=>require(['@/views/backstage/branch_dynamic'],resolve)
        },
        {
          path: '/industrynews',
          name: 'industrynews',
          component:resolve=>require(['@/views/backstage/industry_news'],resolve)
        },
        {
          path: '/noticemanage',
          name: 'noticemanage',
          component:resolve=>require(['@/views/backstage/notice_manage'],resolve)
        },
        {
          path: '/proceedingmanage',
          name: 'proceedingmanage',
          component:resolve=>require(['@/views/backstage/proceeding_manage'],resolve)
        },
        {
          path: '/backstage/memberdisplay',
          name: 'backstageMemberdisplay',
          component:resolve=>require(['@/views/backstage/member_display'],resolve)
        },
        {
          path: '/membersShow',
          name: 'membersShow',
          component:resolve=>require(['@/views/backstage/members_show'],resolve)
        },
        {
          path: '/specialcase',
          name: 'specialcase',
          component:resolve=>require(['@/views/backstage/special_case'],resolve)
        },
        {
          path: '/lawsregulations',
          name: 'lawsregulations',
          component:resolve=>require(['@/views/backstage/laws_regulations'],resolve)
        },
        {
          path: '/lawyercorpus',
          name: 'lawyercorpus',
          component:resolve=>require(['@/views/backstage/lawyer_corpus'],resolve)
        },
        {
          path: '/branchintroduce',
          name: 'branchintroduce',
          component:resolve=>require(['@/views/backstage/branch_introduce'],resolve)
        },
        {
          path: '/courtrecommend',
          name: 'courtrecommend',
          component:resolve=>require(['@/views/backstage/court_recommend'],resolve)
        },
        {
          path: '/feedbackmanage',
          name: 'feedbackmanage',
          component:resolve=>require(['@/views/backstage/feedback_manage'],resolve)
        },
        {
          path: '/backstagecreate/:type',
          name: 'backstagecreate',
          component:resolve=>require(['@/views/backstage/backstage_create'],resolve)
        },
        {
          path: '/notice_announcement/:type',
          name: 'notice_announcement',
          component:resolve=>require(['@/views/backstage/notice_announcement'],resolve)
        },
        {
          path: '/special_details/:type',
          name: 'special_details',
          component:resolve=>require(['@/views/backstage/special_details'],resolve)
        },
        {
          path: '/Industry_details/:type',
          name: 'Industry_details',
          component:resolve=>require(['@/views/backstage/Industry_details'],resolve)
        },
        {
          path: '/new_branch/:type',
          name: 'new_branch',
          component:resolve=>require(['@/views/backstage/new_branch'],resolve)
        },
        {
          path: '/new_statute/:type',
          name: 'new_statute',
          component:resolve=>require(['@/views/backstage/new_statute'],resolve)
        },
        {
          path: '/slideshow',
          name: 'slideshow',
          component:resolve=>require(['@/views/backstage/slideshow'],resolve)
        },
        {
          path: '/new_difficult_cases/:type',
          name: 'new_difficult_cases',
          component:resolve=>require(['@/views/backstage/new_difficult_cases'],resolve)
        },
        {
          path: '/new_Proceedings/:type',
          name: 'new_Proceedings',
          component:resolve=>require(['@/views/backstage/new_Proceedings'],resolve)
        },
        {
          path: '/member_show/:type',
          name: 'member_show',
          component:resolve=>require(['@/views/backstage/member_show'],resolve)
        },
        {
          path: '/trainingcreate',
          name: 'trainingcreate',
          component:resolve=>require(['@/views/admin/training_create'],resolve)
        },
        {
          path: '/exammanage',
          name: 'exammanage',
          component: resolve => require(['@/views/admin/exam_manage'], resolve)
        },
        {
          path: '/undefined/:type',
          name: 'undefined',
          component:resolve=>require(['@/views/undefined'],resolve)
        },
        {
          path: '/applycertificate/:purl',
          name: 'applycertificate',
          component:resolve=>require(['@/views/member/apply_certificate'],resolve)
        },
        {
          path: '/changecertificate/:purl',
          name: 'changecertificate',
          component:resolve=>require(['@/views/member/change_certificate'],resolve)
        },
        {
          path: '/handleDetails',
          name: 'handleDetails',
          component:resolve=>require(['@/views/member/handle_details'],resolve)
        },
        {
          path: '/advicefeedback',
          name: 'advicefeedback',
          component:resolve=>require(['@/views/member/advice_feedback'],resolve)
        },
        {
          path: '/mysafety',
          name: 'mysafety',
          component:resolve=>require(['@/views/member/my_safety'],resolve)
        },
        {
          path: '/editlogin/:type',
          name: 'editlogin',
          component:resolve=>require(['@/views/member/edit_login'],resolve)
        },
        {
          path: '/adddues/:type',
          name: 'adddues',
          component:resolve=>require(['@/views/member/add_dues'],resolve)
        },
        {
          path: '/supplementfile',
          name: 'supplementfile',
          component:resolve=>require(['@/views/member/supplement_file'],resolve)
        },
        {
          path: '/infodisplay',
          name: 'infodisplay',
          component:resolve=>require(['@/views/member/info_display'],resolve)
        },
        {
          path: '/InstitutionalDisplay',
          name: 'InstitutionalDisplay',
          component:resolve=>require(['@/views/member/Institutional_Display'],resolve)
        },
        {
          path: '/Institutionaladddisplay',
          name: 'Institutionaladddisplay',
          component:resolve=>require(['@/views/member/Institutional_add_display'],resolve)
        },
        {
          path: '/Institutionaleditdisplay',
          name: 'Institutionaleditdisplay',
          component:resolve=>require(['@/views/member/Institutional_edit_display'],resolve)
        },
        {
          path: '/Institutionaldeletedisplay',
          name: 'Institutionaldeletedisplay',
          component:resolve=>require(['@/views/member/Institutional_delete_display'],resolve)
        },
        {
          path: '/bizduesdetails',
          name: 'bizduesdetails',
          component:resolve=>require(['@/views/member/biz_dues_details'],resolve)
        },
        {
          path: '/renewalContributions',
          name: 'renewalContributions',
          component:resolve=>require(['@/views/admin/renewal_contributions'],resolve)
        },
        {
          path: '/personalmemberedit',
          name: 'personalmemberedit',
          component:resolve=>require(['@/views/admin/personal_member_edit'],resolve)
        },
        {
          path: '/memberedit',
          name: 'memberedit',
          component:resolve=>require(['@/views/admin/member_edit'],resolve)
        },
        {
          path: '/supplementfileedit',
          name: 'supplementfileedit',
          component:resolve=>require(['@/views/member/supple_mentfile_edit'],resolve)
        },
        {
          path: '/detailsmembership',
          name: 'detailsmembership',
          component:resolve=>require(['@/views/member/details_membership'],resolve)
        },
        {
          path: '/adminchangeupdata',
          name: 'adminchangeupdata',
          component:resolve=>require(['@/views/admin/admin_change_updata'],resolve)
        },
        {
          path: '/adminchangeadd',
          name: 'adminchangeadd',
          component:resolve=>require(['@/views/admin/admin_change_add'],resolve)
        },
        {
          path: '/adminchangedelete',
          name: 'adminchangedelete',
          component:resolve=>require(['@/views/admin/admin_change_delete'],resolve)
        },
        {
          path: '/adminchangeedit',
          name: 'adminchangeedit',
          component:resolve=>require(['@/views/admin/admin_change_edit'],resolve)
        },
        {
          path: '/infochangemechanism',
          name: 'infochangemechanism',
          component:resolve=>require(['@/views/member/info_change_mechanism'],resolve)
        },
        {
          path: '/infonewproper',
          name: 'infonewproper',
          component:resolve=>require(['@/views/member/info_new_proper'],resolve)
        },
        {
          path: '/infochangeproper',
          name: 'infochangeproper',
          component:resolve=>require(['@/views/member/info_change_proper'],resolve)
        },
        {
          path: '/infoeditproper',
          name: 'infoeditproper',
          component:resolve=>require(['@/views/member/info_edit_proper'],resolve)
        },
        {
          path: '/infochangedelete',
          name: 'infochangedelete',
          component:resolve=>require(['@/views/member/info_change_delete'],resolve)
        },
        {
          path: '/infochangeupdata',
          name: 'infochangeupdata',
          component:resolve=>require(['@/views/member/info_change_updata'],resolve)
        },
        {
          path: '/memberdisplayeditor',
          name: 'memberdisplayeditor',
          component:resolve=>require(['@/views/member/member_display'],resolve)
        },
        {
          path: '/chargecertificate',
          name: 'chargecertificate',
          component:resolve=>require(['@/views/member/charge_certificate'],resolve)
        },
        {
          path: '/orgrecommended',
          name: 'orgrecommended',
          component:resolve=>require(['@/views/organization/org_recommended'],resolve)
        },
        {
          path: '/agencyquery',
          name: 'agencyquery',
          component:resolve=>require(['@/views/organization/agency_query'],resolve)
        },
        {
          path: '/memberquery',
          name: 'memberquery',
          component:resolve=>require(['@/views/organization/member_query'],resolve)
        },
        {
          path: '/testregister',
          name: 'testregister',
          component:resolve=>require(['@/views/member/test_register'],resolve)
        },
        {
          path: '/usermanage',
          name: 'usermanage',
          component:resolve=>require(['@/views/admin/user_manage'],resolve)
        },
        {
          path: '/rolemanage',
          name: 'rolemanage',
          component:resolve=>require(['@/views/admin/role_manage'],resolve)
        },
        {
          path: '/departmentmanage',
          name: 'departmentmanage',
          component:resolve=>require(['@/views/admin/department_manage'],resolve)
        },
        {
          path: '/workflowmanage',
          name: 'workflowmanage',
          component:resolve=>require(['@/views/admin/workflow_manage'],resolve)
        },
        {
          path: '/workflowadd',
          name: 'workflowadd',
          component:resolve=>require(['@/views/admin/workflow_add'],resolve)
        },
        {
          path: '/registrationdetails',
          name: 'registrationdetails',
          component:resolve=>require(['@/views/admin/registration_details'],resolve)
        },
        {
          path: '/trainingHistoryTrainers',
          name: 'trainingHistoryTrainers',
          component:resolve=>require(['@/views/admin/training_History_Trainers'],resolve)
        },
        {
          path: '/detailsTraining',
          name: 'detailsTraining',
          component:resolve=>require(['@/views/admin/details_Training'],resolve)
        },
        {
          path: '/infochangerecord',
          name: 'infochangerecord',
          component:resolve=>require(['@/views/member/info_change_record'],resolve)
        },
        {
          path: '/registrationexamination',
          name: 'registrationexamination',
          component:resolve=>require(['@/views/member/registration_examination'],resolve)
        },
        {
          path: '/traninbrowse',
          name: 'traninbrowse',
          component:resolve=>require(['@/views/member/tranin_browse'],resolve)
        },
        {
          path: '/bizduesreport',
          name: 'bizduesreport',
          component:resolve=>require(['@/views/member/biz_dues_report'],resolve)
        },
        {
          path: '/membershiprenewal',
          name: 'membershiprenewal',
          component:resolve=>require(['@/views/member/membership_renewal'],resolve)
        },
        {
          path: '/detailsofrenewal',
          name: 'detailsofrenewal',
          component:resolve=>require(['@/views/member/details_of_renewal'],resolve)
        },
        {
          path: '/paymenttrainingapprovalhy',
          name: 'paymenttrainingapprovalhy',
          component:resolve=>require(['@/views/member/payment_training_approvalhy'],resolve)
        },
        {
          path: '/paymentapprovalhy',
          name: 'paymentapprovalhy',
          component:resolve=>require(['@/views/member/payment_approvalhy'],resolve)
        },
        {
          path: '/applytraindetail',
          name: 'applytraindetail',
          component:resolve=>require(['@/views/member/apply_train_detail'],resolve)
        },
        {
          path: '/businessstatistics',
          name: 'businessstatistics',
          component:resolve=>require(['@/views/admin/business_statistics'],resolve)
        },
        
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js